import { PrintToPdfWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  SchemaProvider,
  WorkflowNodeSchemaProvider,
} from '../../registry/schema-provider.registry';

@WorkflowNodeSchemaProvider('PrintToPdf')
export class PrintToPdfNodeSchemaProvider extends SchemaProvider<PrintToPdfWorkflowNode> {}
